import PropTypes from 'prop-types'
import { Stack, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useFormik } from 'formik';
import * as yup from 'yup';

import TextField from 'components/TextField';

import { updateGlobalContractParams } from 'services/requests/globalContractParams';
import { toast } from 'utils';

const initialValues = {
  templateZapSign: ''
};

export default function GlobalContractParamsForm({ defaultValues, onSuccess }) {
  const validationSchema = yup.object({
    templateZapSign: yup.string()
      .required('Obrigatório')
      .min(1, 'O Template ZapSign é obrigatório')
  });

  const formik = useFormik({
    initialValues: defaultValues || initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      updateGlobalContractParams({ body: { ...values } })
        .then(() => {
          toast('Configurações atualizadas com sucesso', 'success');
          onSuccess?.();
        })
        .catch((err) => toast(err, 'error'))
        .finally(() => setSubmitting(false));
    },
  });

  return (
    <>
      <Stack spacing={3}>
        <TextField
          fullWidth
          name="templateZapSign"
          label="Template ZapSign"
          value={formik.values.templateZapSign || ''}
          onChange={formik.handleChange}
          error={formik.touched.templateZapSign && Boolean(formik.errors.templateZapSign)}
          helperText={formik.touched.templateZapSign && formik.errors.templateZapSign || 'ID do template do ZapSign para assinatura digital'}
        />
      </Stack>

      <Stack direction="column" alignItems="end" justifyContent="end" mt={3}>
        <LoadingButton
          size="large"
          type="submit"
          color="secondary"
          variant="contained"
          onClick={() => formik.handleSubmit()}
          loading={formik.isSubmitting}
        >
          Salvar
        </LoadingButton>

        <Typography variant="body2" sx={{ maxWidth: '360px', textAlign: 'right', mt: 2 }}>
          As novas configurações salvas passam a ser válidas apenas para contratos futuros, a partir do momento em que esses novos valores são salvos.
        </Typography>
      </Stack>
    </>
  );
}

GlobalContractParamsForm.propTypes = {
  defaultValues: PropTypes.object,
  onSuccess: PropTypes.func
}

